const API_URL = '/export'

export const state = () => ({
  filter_options: {},
  export_data: [],
})

export const getters = {
  getFilterOptions: state => {
    return state.filter_options
  },
  getExportData: state => branch_id => {
    return state.export_data[branch_id] || {}
  },
}

export const mutations = {
  PUSH_OR_REPLACE_FILTER_OPTIONS(state, filterOptions) {
    state.filter_options = filterOptions
  },
  PUSH_OR_REPLACE_EXPORT_DATA(state, data) {
    state.export_data[data.wasteCompanyBranchId] = data
  },
}

export const actions = {
  async fetchFilterOptions({ commit }, { WasteCompanyBranchId, params }) {
    let { data: options } = await useApi(`${API_URL}/${WasteCompanyBranchId}/waste-customers/filter-options`, {
      params,
    })

    commit('PUSH_OR_REPLACE_FILTER_OPTIONS', options.value)

    return options.value
  },
  async fetchWasteCustomersExportData({ commit }, { waste_company_branch_id, params }) {
    let { data } = await useApi(`${API_URL}/${waste_company_branch_id}/waste-customers`, {
      method: 'post',
      body: params,
    })

    commit('PUSH_OR_REPLACE_EXPORT_DATA', data.value)

    return data.value
  },
  async exportFile({ commit }, { waste_company_branch_id, params, exportFormat }) {
    let url = `${API_URL}/${waste_company_branch_id}/waste-customers/export`

    if (exportFormat) {
      url += `?exportFormat=${exportFormat}`
    }

    let { data } = await useApi(url, {
      method: 'post',
      body: params,
      responseType: 'blob',
    })

    return data.value
  },
}
